import { useSelector, shallowEqual } from "react-redux";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import PropTypes from "prop-types";
import MarketingBanner from "app/pages/Header/MarketingBanner/MarketingBanner";

const mapStateToProps = state => {
	return {
		userIsConnected: isAuthenticated(state),
	};
};

const MarketingBannerContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <MarketingBanner {...props} {...stateProps} />;
};

MarketingBannerContainer.propTypes = {
	banners: PropTypes.array,
};

export default MarketingBannerContainer;
